/**
 * The Big search bar selector, used to calculate offsets between the header search bar and the hero one.
 * @type {String}
 */
export const SUB_CATEGORIES_SELECTOR = '.logged-out-homepage .sub-categories-section';
